import './index.css';
import * as ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'mobx-react';
import Utils from './utils/utils';
import abpUserConfigurationService from './services/abpUserConfigurationService';
import initializeStores from './stores/storeInitializer';
import registerServiceWorker from './registerServiceWorker';
import moment from "moment-timezone";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./authConfig";
import React from 'react';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
import { registerIcons } from '@fluentui/react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';

initializeIcons();
registerIcons({
  icons: {
    none: '',
  },
});

const msalInstance = new PublicClientApplication(msalConfig);
declare var abp: any;

Utils.setLocalization();

function mountApp() {
  const stores = initializeStores();

  ReactDOM.render(
    <MsalProvider instance={msalInstance}>
      <Provider {...stores}>
        <BrowserRouter>
          <FluentProvider theme={webLightTheme}>
            <App />
          </FluentProvider>
        </BrowserRouter>
      </Provider>
    </MsalProvider>
    ,
    document.getElementById('root') as HTMLElement
  );

  registerServiceWorker();
}

function applyUserConfiguration(result: any) {
  if (!result) {
    return;
  }
  Utils.extend(true, abp, result);
  if (result.clock && result.clock.provider) {
    abp.clock.provider = Utils.getCurrentClockProvider(result.clock.provider);
  }
  abp.utils.setCookieValue(
    'Abp.Auth',
    result.auth ? JSON.stringify(result.auth) : null,
    new Date(new Date().getTime() + 5 * 365 * 86400000),
    abp.appPath
  );
  if (abp.localization && abp.localization.currentLanguage && abp.localization.currentLanguage.name) {
    moment.locale(abp.localization.currentLanguage.name);
  }
  if (
    abp.clock &&
    abp.clock.provider &&
    abp.clock.provider.supportsMultipleTimezone &&
    abp.timing &&
    abp.timing.timeZoneInfo &&
    abp.timing.timeZoneInfo.iana
  ) {
    moment.tz.setDefault(abp.timing.timeZoneInfo.iana.timeZoneId);
  }
}

abpUserConfigurationService.getAll().then(data => {
  applyUserConfiguration(data && data.data ? data.data.result : undefined);
  mountApp();
}).catch((error: any) => {
  console.error(error);

  const allowLoginShell = /^\/(user\/login|account\/)/.test(window.location.pathname);
  if (allowLoginShell) {
    mountApp();
    return;
  }

  ReactDOM.render(
    <FluentProvider theme={webLightTheme}>
      <h1 style={{textAlign: 'center', textWrap: 'auto', whiteSpace: 'pre-wrap'}}>
        Nie udało się pobrać AbpUserConfiguration. Skontaktuj się z administratorem.
        <br /><br /><br /><br />
        Failed to download AbpUserConfiguration. Please contact your administrator.
      </h1>
    </FluentProvider>
    ,
    document.getElementById('root') as HTMLElement
  );
});
